import { AudioListener, PositionalAudio, AudioLoader } from "three"

const buttonMute = document.querySelector('button.buttonMute')
const imageSpeaker = "url('/speaker.webp')"
const imageMute = "url('/mute.webp')"

const musicPath = {
    musicOne: '/music/musicOne.mp3', 
    musicTwo: '/music/musicTwo.mp3', 
}
export let sound
export let music = {}

export const playMusic = (camera, loadingManager) =>{
    const listener = new AudioListener()
    camera.add(listener)

    sound = new PositionalAudio(listener)

    const audioLoader = new AudioLoader(loadingManager)

    for(let key in musicPath){
        audioLoader.load(musicPath[key], (buffer) =>{
        music[key] = buffer

        if(key === 'musicOne'){
            sound.setBuffer(buffer)
            sound.setRefDistance(2)
            sound.setRolloffFactor(0.8)
            sound.setLoop(true)
            sound.setVolume(0.4)  
        }
        })
    }
}


buttonMute.addEventListener('click', ()=>{
    const isMuted = sound.getVolume() === 0
    sound.setVolume(isMuted ? 0.4 : 0)
   buttonMute.style.backgroundImage = isMuted ? imageSpeaker : imageMute
})  